<div class="min-h-screen bg-slate-200 py-6 px-4 flex flex-col items-center">
  <div class="w-full max-w-sm">
    <!-- Ticket / Recibo -->
    <div
      class="bg-white rounded-lg shadow-md overflow-hidden border border-slate-300 print:shadow-none print:border print:max-w-none">
      <!-- Cabecera tipo ticket -->
      <div class="bg-slate-800 text-white px-4 py-4 text-center">
        <div class="inline-flex items-center justify-center w-12 h-12 rounded-full bg-emerald-500/90 mb-2">
          <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        <h1 class="text-lg font-bold tracking-wide uppercase">Pago recibido</h1>
        <p class="text-slate-300 text-xs mt-1">Tu pago fue procesado correctamente</p>
      </div>

      @if (loading()) {
      <div class="px-4 py-8 text-center">
        <div class="inline-block animate-spin rounded-full h-8 w-8 border-2 border-slate-400 border-t-transparent">
        </div>
        <p class="text-slate-500 text-sm mt-3">Cargando recibo...</p>
      </div>
      } @else if (error()) {
      <div class="px-4 py-8 text-center text-slate-500 text-sm">
        No se pudo cargar el resumen de la factura.
      </div>
      } @else if (summary(); as s) {
      <div class="px-4 py-4 space-y-4">
        <!-- Datos del recibo -->
        <div class="border-b border-dashed border-slate-300 pb-3">
          <p class="text-[10px] uppercase tracking-wider text-slate-400">Factura</p>
          <div class="flex justify-between gap-2">
            <p class="font-mono font-semibold text-slate-800">
              @if (s.series) {
              <span class="text-slate-500">{{ s.series }} </span>
              }
              {{ s.invoiceNumber }}
            </p>
            <p class="text-slate-500 text-xs"></p>
            <p-tag severity="success" ><p class="text-xs">Pago {{ s.paymentNumber }} de {{ s.numberOfPayments }}</p></p-tag>
          </div>
        </div>
        <div class="border-b border-dashed border-slate-300 pb-3">
          <p class="text-[10px] uppercase tracking-wider text-slate-400">Cliente</p>
          <p class="text-slate-800 text-sm">{{ s.customerName || '—' }}</p>
          <small class="text-slate-500 text-xs font-mono">{{ s.customerTaxId || '—' }}</small>
        </div>
        @if (s.paidAt) {
        <div class="border-b border-dashed border-slate-300 pb-3">
          <p class="text-[10px] uppercase tracking-wider text-slate-400">Fecha de pago</p>
          <p class="text-slate-800 text-sm">{{ formatDate(s.paidAt) }}</p>
        </div>
        }

        <!-- Líneas -->
        @if (s.lines && s.lines.length > 0) {
        <div class="border-b border-dashed border-slate-300 pb-3">
          <p class="text-[10px] uppercase tracking-wider text-slate-400 mb-2">Detalle</p>
          <div class="space-y-2 text-sm">
            @for (line of s.lines; track line.description + $index) {
            <div class="flex justify-between gap-2  pb-1.5 last:border-0">
              <span class="text-slate-700 flex-1 min-w-0">{{line.quantity}} × {{ line.description }}</span>
              <span class="text-slate-800 shrink-0 font-mono">{{ formatAmount(line.totalAmount, s.currency) }}</span>
            </div>
            }
          </div>
        </div>
        }

        <!-- Total -->
        <div class="flex justify-between items-baseline pt-2 border-t-2 border-slate-800">
          <span class="text-sm font-semibold uppercase text-slate-600">Total pagado</span>
          <span class="text-lg font-bold font-mono text-slate-900">{{ formatAmount(s.totalAmount, s.currency) }}</span>
        </div>
      </div>
      }
    </div>
  </div>
</div>